import React, { useState, useEffect } from "react";
import {
  Image,
  Grid,
  Header,
  Segment,
  StatisticGroup,
  Statistic,
  Placeholder,
  PlaceholderParagraph,
} from "semantic-ui-react";
import { YouTubeChannelInfo } from "../../types/YouTube.types";
import { withCommas } from "../utils";

const ChannelInfo = () => {
  const [
    {
      channelThumbnail,
      subscriberCount,
      videoCount,
      viewCount,
      title,
      description,
    },
    setChannelInfo,
    // @ts-ignore
  ] = useState<YouTubeChannelInfo & { since: Date }>({});

  const getChannelInfo = async () => {
    const res = await fetch("/api/YouTube/getChannel");
    const { publishedAt, ...newData } = await res.json();
    setChannelInfo({ ...newData, since: new Date(publishedAt || "") });
  };

  useEffect(() => {
    getChannelInfo();
  }, []);

  return (
    <Grid.Row centered>
      <Grid.Column mobile={14} computer={3}>
        {channelThumbnail ? (
          <Segment vertical inverted>
            <Image src={channelThumbnail} size="small" circular centered />
          </Segment>
        ) : (
          <Placeholder fluid inverted>
            <Placeholder.Image square />
          </Placeholder>
        )}
      </Grid.Column>
      <Grid.Column mobile={14} computer={11}>
        {channelThumbnail ? (
          <>
            <Header inverted as="h1">
              {title}
            </Header>
            <Header inverted as="h3">
              {description}
            </Header>
            <StatisticGroup widths="3">
              <Statistic
                value={withCommas(viewCount)}
                color="red"
                label="Views"
                inverted
              />
              <Statistic
                color="orange"
                value={withCommas(subscriberCount)}
                label="Subscribers"
                inverted
              />
              <Statistic
                value={videoCount}
                label="Videos"
                color="yellow"
                inverted
              />
              {/*<Statistic
                  value={`${since.getFullYear()}/${since.getMonth()}`}
                  label="Since"
                />*/}
            </StatisticGroup>
          </>
        ) : (
          <Placeholder fluid inverted>
            <Placeholder.Header>
              <Placeholder.Header />
              <Placeholder.Header />
            </Placeholder.Header>
            <Placeholder.Header>
              <Placeholder.Header />
              <Placeholder.Header />
            </Placeholder.Header>
            <PlaceholderParagraph>
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </PlaceholderParagraph>
          </Placeholder>
        )}
      </Grid.Column>
    </Grid.Row>
  );
};

export default ChannelInfo;
